import { FeatureFlag, Site } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useMemo } from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import PhoneNumberInput from '@swf/components/PhoneNumberInput/PhoneNumberInput';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import { getCountryShortName } from '@swf/core/utils/phoneVerification';

import {
  TXTCLI_Continue,
  TXTWCL_Verify_my_number,
  TXTWCL_WeXll_use_this_for_account_sec_ELL,
  TXTWCL_We_need_your_mobile_number_to__ELL
} from './VerifyNumber.messages.json';
import styles from './VerifyNumber.scss';

interface Props {
  first?: boolean;
  verifyNumber?(): void;
  callingCode?: string;
  phoneVefification?: boolean;
  phoneFormatCountry?: string;
  autoFocus?: boolean;
}

const VerifyNumber: React.FC<React.PropsWithChildren<Props>> = ({
  first = false,
  verifyNumber,
  children,
  callingCode,
  phoneFormatCountry,
  autoFocus
}) => {
  const site = useSelector(select.cms.getSiteId);
  const swcRMFPhoneVerification = useFeature(FeatureFlag.SwcRMFPhoneVerification);
  const form = useForm();
  const { values } = form.getState();
  const userCountry = useSelector(select.account.getCountry);

  const country = useMemo(() => {
    if (values.dialingCode && values.dialingCode.length < 3) return values.dialingCode;
    if (values.country && values.dialingCode && values.dialingCode.length > 2)
      return getCountryShortName(values.country);
    if (callingCode) return callingCode;
    if (userCountry) return userCountry;
    return values?.country;
  }, [values.dialingCode, values?.country, callingCode, userCountry]);

  return (
    <>
      <p className={styles.paragraph}>
        <Translation
          {...(site === Site.CAON || site === Site.USMI
            ? TXTWCL_WeXll_use_this_for_account_sec_ELL
            : TXTWCL_We_need_your_mobile_number_to__ELL)}
        />
      </p>
      <div className={classNames(styles.inputWrapper, verifyNumber && styles.inputColumnWrapper)}>
        {children}
        <PhoneNumberInput
          callingCode={callingCode}
          phoneFormatCountry={country || phoneFormatCountry}
          autoFocus={autoFocus}
        />
      </div>
      <StarsButton
        block
        onClick={verifyNumber}
        type={first ? 'submit' : 'button'}
        className={classNames(styles.button, { [styles.first]: first })}
        translation={swcRMFPhoneVerification || !first ? TXTWCL_Verify_my_number : TXTCLI_Continue}
      />
    </>
  );
};

export default VerifyNumber;
